<template>
	<div>
		<h2>
			Helderheid
		</h2>
		<p>Je gaat nu de helderheid meten van het water, gebruik daarvoor je secchi-schijf of secchi-hark. Meet het doorzicht en de bodemdiepte. Zie handleiding voor meetinstructies. Rond af op 10 cm.</p>
		<fieldset>
			<SelectInput
				label="Doorzicht"
				placeholder="Doorzicht"
				name="transparency"
				v-model="localMeasurement.transparency"
				:options="[
					'  0 cm',
					' 10 cm' ,
					' 20 cm' ,
					' 30 cm' ,
					' 40 cm' ,
					' 50 cm' ,
					' 60 cm' ,
					' 70 cm' ,
					' 80 cm' ,
					' 90 cm' ,
					'100 cm' ,
					'110 cm' ,
					'120 cm' ,
					'130 cm' ,
					'140 cm' ,
					'150 cm' ,
					'160 cm' ,
					'170 cm',
					'Meer dan 170 cm',
				]"
			/>

			<SelectInput
				label="Bodemdiepte"
				placeholder="Bodemdiepte"
				name="depth"
				v-model="localMeasurement.depth"
				:min-value="localMeasurement.transparency"
				:options="[
					'  0 cm',
					' 10 cm' ,
					' 20 cm' ,
					' 30 cm' ,
					' 40 cm' ,
					' 50 cm' ,
					' 60 cm' ,
					' 70 cm' ,
					' 80 cm' ,
					' 90 cm' ,
					'100 cm' ,
					'110 cm' ,
					'120 cm' ,
					'130 cm' ,
					'140 cm' ,
					'150 cm' ,
					'160 cm' ,
					'170 cm',
					'Meer dan 170 cm',
				]"
			/>
		</fieldset>
		<nav>
			<button @click.prevent="$emit('back')" type="button" class="btn-prev">Terug</button>
			<button @click.prevent="$emit('save', localMeasurement)" class="btn-next" :disabled="!fieldsComplete">
				Volgende
			</button>
		</nav>
	</div>
</template>

<script>
import SelectInput from './components/SelectInput.vue';
import SingleCheckbox from './components/SingleCheckbox.vue';
import FormStep from './FormStep.vue';

export default {
	name: 'FormStep7',
	components: { SelectInput, SingleCheckbox },
	mixins: [FormStep],
	data() {
		return {
			fieldRequirements: {
				transparency: ['required'],
				depth: ['required'],
			},
		};
	},
};
</script>

<style scoped></style>
